<!--  -->
<template>
  <input
    :class="cl(
      'input',
      type,
    )"
    v-model.trim="val"
    :placeholder="placeHolder(type)"
    @input="handleChange"
    @blur="handleBlur"
  />
</template>

<script>
export default {
  props: {
    type: {
      validator(value) {
        return ['input', 'tel', 'code', 'encode', 'account', 'password'].indexOf(value) !== -1;
      },
      default: 'input',
    },
  },
  data() {
    return {
      val: '',
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    placeHolder(type) {
      if (type === 'tel') return '请输入手机号';
      if (type === 'code') return '短信验证码';
      if (type === 'encode') return '英文验证码';
      if (type === 'account') return '请输入账号';
      if (type === 'password') return '请输入密码';
      return '';
    },
    cl(
      input,
      type,
    ) {
      const result = [input];
      if (type === 'tel') result.push(`input--${type}`);
      if (type === 'code') result.push(`input--${type}`);
      if (type === 'encode') result.push(`input--${type}`);
      if (type === 'account') result.push(`input--${type}`);
      if (type === 'password') result.push(`input--${type}`);
      return result.join(' ');
    },
    handleChange() {
      this.$emit('change', this.val);
    },
    handleBlur() {
      this.$emit('blur', this.val);
    },
  },
};

</script>
<style lang='less' scoped>
@import url('../assets/styles/mixins.less');

.input {
  padding: 0 17px;
  height: 43px;
  line-height: 43px;
  font-size: 16px;
  color:rgba(156,156,156,1);
  border: none;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: transparent;
  outline: none;
  &--tel,
  &--account,
  &--password {
    width: 392px;
    .bg-img('../images/login/input');
  }
  &--code {
    width: 228px;
    .bg-img('../images/login/input_mini');
  }
  &--encode {
    width: 228px;
    .bg-img('../images/login/input_mini');
  }
  &::-webkit-input-placeholder {
    font-size: 16px;
    color:rgba(156,156,156,1);
  }
}
</style>
